export enum BudgetFields {
  TentativePlanned = 'tentativePlanned',
  NonTentativePlanned = 'nonTentativePlanned',
  Holiday = 'holiday',
  Pto = 'pto',
  Capacity = 'capacity',
}

export interface BudgetFieldConfig {
  id: BudgetFields;
  color: string;
  label: string;
}

export const capacityConfig: BudgetFieldConfig = {
  id: BudgetFields.Capacity,
  color: '#cdcdcd',
  label: 'Capacity',
};

export const tentativePlannedConfig: BudgetFieldConfig = {
  id: BudgetFields.TentativePlanned,
  color: '#b9ba59',
  label: 'Tentative',
};

export const nonTentativePlannedConfig: BudgetFieldConfig = {
  id: BudgetFields.NonTentativePlanned,
  color: '#F3F574',
  label: 'Planned',
};

export const holidayConfig: BudgetFieldConfig = {
  id: BudgetFields.Holiday,
  color: '#3071c7',
  label: 'Holiday',
};

export const ptoConfig: BudgetFieldConfig = {
  id: BudgetFields.Pto,
  color: '#9bc2e8',
  label: 'PTO',
};
